import styled, { css } from 'styled-components';

export const BannerStyle = styled.div<{
  $bg?: string;
  $mobile?: string;
  $overlay?: string;
  $loaderDefault?: string;
  $loaderMobile?: string;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (min-width: 769px) {
    max-width: 1132px;
    border-radius: 12px;
  }

  aspect-ratio: 257 / 49;
  background-image: url('${(props) => props.$bg}'), url('${(props) => props.$loaderDefault}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
  cursor: pointer;

  ${(props) =>
    props.$overlay &&
    css`
      &:after {
        content: '';
        position: absolute;
        background-image: url('${props.$overlay}');
        background-repeat: no-repeat;
        background-size: contain;
        width: clamp(220px, 48%, 550px);
        aspect-ratio: 1423 / 367;
        top: 50%;
        left: 30%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
    `}

  @media (max-width: 768px) {
    aspect-ratio: 93 / 64;
    border-radius: 0;
    margin-top: 0;
    background-image: url('${(props) => props.$mobile}'),
      url('${(props) => props.$loaderMobile}');

    &:after {
      display: none;
    }
  }
`;
